import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=2f89c39a"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"
import style0 from "./trainDetail.vue?vue&type=style&index=0&id=2f89c39a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports